<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="New Year" @close="close()" />

      <v-card-text>
        <v-row>
          <!-- Existing Year field -->
          <v-col cols="12" sm="12">
            <v-text-field
              outlined autofocus
              :hide-details="nameErrors.length === 0"
              dense
              :error-messages="nameErrors"
              v-model="Year.name"
              label="Year"
            ></v-text-field>
          </v-col>
          <!-- Select Department dropdown -->
          <v-col cols="12" sm="12">
            <v-autocomplete 
              v-model="Year.ClassId" 
              :items="Classes" 
              item-text="name" 
              item-value="id" 
              label="Select Department" 
              outlined 
              dense 
              clearable 
              :error-messages="classErrors"
              hide-details>
              <template v-slot:item="{ item }">
                <div>{{ item.name }}</div>
              </template>
            </v-autocomplete>
          </v-col>
         <!-- Notes  -->
          <v-col cols="12" sm="12">
              <v-textarea
                outlined
                v-model="Year.note"
                label="Notes"
                id="note"
              ></v-textarea>
            </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import yearService from "../service.js";
import classesService from "@/modules/Classes/service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-year",
  props: {
    createDialog: {
      default: false,
    },
    createFromStore: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      Year: {
        name: null,
        ClassId: null, // Added for the selected class
        note: null,  // Added for the notes 
      },
      Classes: [], // Added for the dropdown
    };
  },
  mixins: [validationMixin],
  validations: {
    Year: {
      name: { required },
      ClassId: { required }, // Validation for the ClassId
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      if (val) {
        this.getClasses(); // Fetch classes when the dialog opens
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Year.name.$dirty) return errors;
      if (!this.$v.Year.name.required) 
          errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    classErrors() {
      const errors = [];
      if (!this.$v.Year.ClassId.$dirty) return errors;
      if  (!this.$v.Year.ClassId.required) 
      errors.push("Department selection is required");
      return errors;
    }
  },
  mounted() {
    this.getClasses(); // Fetch classes as soon as the component is mounted
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Year = {
        name: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      console.clear() 
      console.log('submit', this.$v)
      if (this.$v.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return yearService
          .create(this.Year)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Year is created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
    getClasses() {
      classesService.getAll().then(response => {
        this.Classes = response.data;
      }).catch(err => {
        console.error("Error fetching classes:", err);
      });
    },
  },
};
</script>


<style scoped></style>
